import React from 'react';
import { Modal, Button } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';
// import { customerFailedEmail } from '../store/emails/emailActions';
// import Loading from './Laoding';









function ThreeDSecureModal({modalContent,  show, onHide }){
    // const dispatch = useDispatch();
    // const loading = useSelector((state) => state.email.loading);
    const htmlContent = modalContent;
    const parser = new DOMParser();
    const doc = parser.parseFromString(modalContent, "text/html");
    // Get the title from the HTML or set a fallback message
    const title = doc.querySelector("title")?.innerText || "3-D Secure Verification";
    // let emailSent = false;

    // function checkAndSendEmail() {
    //     if (!emailSent && doc.querySelector("title")?.innerText) {
    //         const emailData = {
    //             toEmail: "excenodeveloper@gmail.com",
    //             fullName: "Adeel Sabir",
    //             productName: "Test Product",
    //             sessionReference: "SH125484",
    //         };
    //         dispatch(customerFailedEmail(emailData));
    //         emailSent = true; // Mark as sent
    //     }
    // }
    

    return(<>
        {/* {loading ? <Loading/> : null} */}
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='text-center' dangerouslySetInnerHTML={{ __html: htmlContent }} />
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                Close
                </Button>
            </Modal.Footer>
        </Modal>
    </>);
}






export default ThreeDSecureModal;